import { render, staticRenderFns } from "./notDate.vue?vue&type=template&id=751fe3d8&scoped=true&"
var script = {}
import style0 from "./notDate.vue?vue&type=style&index=0&id=751fe3d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751fe3d8",
  null
  
)

export default component.exports